var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0.0576172C2.22222 0.0576172 0 2.20083 0 4.87984C0 7.55885 2.22222 9.70206 5 9.70206C7.77778 9.70206 10 7.55885 10 4.87984C10 2.20083 7.77778 0.0576172 5 0.0576172ZM5 8.63046C2.83333 8.63046 1.11111 6.96947 1.11111 4.87984C1.11111 2.79021 2.83333 1.12922 5 1.12922C7.16667 1.12922 8.88889 2.79021 8.88889 4.87984C8.88889 6.96947 7.16667 8.63046 5 8.63046ZM2.77778 4.34404V5.41564H7.22222V4.34404H2.77778Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minusIcon.3bf7e3b059678148c519e2c7cca3c5ef.svg";
export { ForwardRef as ReactComponent };